<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M14.5435 14.4169C13.1435 14.4169 11.8518 13.7586 11.0101 12.6003C10.8101 12.3253 10.8685 11.9336 11.1435 11.7253C11.4185 11.5169 11.8101 11.5836 12.0185 11.8586C12.6268 12.6836 13.5435 13.1586 14.5435 13.1586C16.2851 13.1586 17.7101 11.7419 17.7101 9.99194C17.7101 8.24192 16.2935 6.82525 14.5435 6.82525C13.3601 6.82525 12.2435 7.45859 11.6351 8.46694L9.4268 12.1419C8.59346 13.5336 7.06849 14.3919 5.45182 14.3919C3.01849 14.3919 1.03516 12.4086 1.03516 9.97528C1.03516 7.54193 3.01849 5.55859 5.45182 5.55859C6.85182 5.55859 8.14349 6.21693 8.98513 7.37526C9.18513 7.65026 9.1268 8.04192 8.8518 8.25025C8.56846 8.45861 8.18516 8.39194 7.97682 8.11692C7.37682 7.30859 6.46016 6.83359 5.46016 6.83359C3.71849 6.83359 2.29349 8.25026 2.29349 10.0003C2.29349 11.7503 3.71016 13.1669 5.46016 13.1669C6.64349 13.1669 7.76016 12.5336 8.36846 11.5253L10.5768 7.85026C11.4101 6.45859 12.9351 5.60025 14.5518 5.60025C16.9851 5.60025 18.9685 7.58359 18.9685 10.0169C18.9685 12.4503 16.9768 14.4169 14.5435 14.4169Z"
      fill="currentColor"
    />
    <path
      d="M5.41667 11.6654C6.33714 11.6654 7.08333 10.9192 7.08333 9.9987C7.08333 9.0782 6.33714 8.33203 5.41667 8.33203C4.49619 8.33203 3.75 9.0782 3.75 9.9987C3.75 10.9192 4.49619 11.6654 5.41667 11.6654Z"
      fill="currentColor"
    />
    <path
      d="M14.5846 11.6654C15.5051 11.6654 16.2513 10.9192 16.2513 9.9987C16.2513 9.0782 15.5051 8.33203 14.5846 8.33203C13.6641 8.33203 12.918 9.0782 12.918 9.9987C12.918 10.9192 13.6641 11.6654 14.5846 11.6654Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'RmuIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>